import React from "react";
import StaticLabels from "../util/staticLabels.json";

const CoveoSearchList = ({ content }) => {
	const details = content && typeof content === "object" ? content : {};
	const language = window.config?.language || "en";
	const normalizedLanguage = language.toLowerCase();
	const localizedLabels = StaticLabels[language] ||StaticLabels.en;
	const products = Array.isArray(details.products)
		? details.products
		: Array.isArray(details.product)
			? details.product
			: [details.product && typeof details.product === "object" ? details.product : details];
	const resultCount = Number.isFinite(Number(details.count)) ? Number(details.count) : products.length;
	const viewAllUrl = details?.failover?.cta?.targetUrl;
	const resultsSummary = (localizedLabels.CoveoResultsSummary || StaticLabels.en.CoveoResultsSummary)
		.replace("{count}", String(resultCount));
	const viewAllLabel = localizedLabels.CoveoViewAllResults;
	const viewSkusLabel = localizedLabels.CoveoViewAllSkus;
	const viewAllPrompt = localizedLabels.CoveoViewAllPrompt;
	const skusLabel = localizedLabels.CoveoSkus;
	const searchResultsLabel = localizedLabels.CoveoSearchResults;
	const productItemLabel = localizedLabels.CoveoProductItem;
	const discontinuedLabel = localizedLabels.CoveoDiscontinued;
	const shouldShowViewAllResults = resultCount >= 10;

	return (
		<div>
        <div className="coveo-search-list" aria-label={searchResultsLabel}>
			<p className="coveo-search-list__summary">
				{resultsSummary}
			</p>
			{shouldShowViewAllResults ? (
				<div className="coveo-search-list__browser-action">
					<p>{viewAllPrompt}</p>
					{viewAllUrl ? (
						<a className="coveo-search-list__button" href={viewAllUrl} target="_blank" rel="noopener noreferrer">
							{viewAllLabel}
						</a>
					) : (
						<button type="button" className="coveo-search-list__button">
							{viewAllLabel}
						</button>
					)}
				</div>
			) : null}
			<div className="coveo-search-list__products">
				{products.map((product, index) => {
					const item = product && typeof product === "object" ? product : {};
					const skus = Array.isArray(item.sku) ? item.sku : item.sku ? [item.sku] : [];
					const productUrl = item.url;
					let fallbackThumbnail = "https://honeywell.scene7.com/is/image/Honeywell65/hbt-icon-drivers-primaryimage";
					const thumbnail = item.thumbnail || fallbackThumbnail;

					return (
						<article className="coveo-search-list__product" key={item.id || item.sku || index}>
							<header className="coveo-search-list__product-header">
								<h3>{item.productFamily || productItemLabel}</h3>
								{item.discontinued === true ? <span className="coveo-search-list__status">{discontinuedLabel}</span> : null}
							</header>
							<div className={`coveo-search-list__product-content${thumbnail ? "" : " coveo-search-list__product-content--without-thumbnail"}`}>
								{thumbnail ? (
									<img
										className="coveo-search-list__thumbnail"
										src={thumbnail}
										alt={item.name || productItemLabel}
										onError={(event) => {
											event.currentTarget.onerror = null;
											event.currentTarget.src = fallbackThumbnail;
										}}
									/>
								) : null}
								<div className="coveo-search-list__product-info">
									<div className="coveo-search-list__details">
										<span className="coveo-search-list__label">{skusLabel}</span>
										<div className="coveo-search-list__sku-grid">
											{skus.map((sku, skuIndex) => (
												<p className="coveo-search-list__sku-value" key={`${sku}-${skuIndex}`}>
													{sku}
												</p>
											))}
										</div>
									</div>
								</div>
							</div>
							{productUrl ? (
								<a className="coveo-search-list__button" href={productUrl} target="_blank" rel="noopener noreferrer">
									{viewSkusLabel}
								</a>
							) : null}
						</article>
					);
				})}
			</div>
		</div>
        </div>
	);
};

export default CoveoSearchList;
